import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";

//primereact
import { Button } from "primereact/button";
//components

import Modal from "../../../../../../../components/modal/Modal";

//services
import Select from "../../../../../../../components/input/Select";
import { postConfigContract } from "../../../../../../../services/Enterprise/ClickSign/postConfigContract";

export const ModalRegisterSigners = ({
  visible,
  setVisible,
  defaultValues,
  idSale,
  newSigner,
  isLoadingSigners,
  setNewSigner,
  signers,
  isLoading,
  config_sign,
  refetchRegisterSigners,
}) => {
  const formSigner = useForm({ defaultValues });
  const errorsFile = formSigner.formState.errors;
  const [loading, setLoading] = useState(false);
  const [transformedData, setTransformedData] = useState([]);

  useEffect(() => {
    formSigner.setValue("file_name", defaultValues?.file_name);
    formSigner.setValue("idDoc", defaultValues?.idFile);
  }, [defaultValues]);

  const transformData = (responseData) => {
    const newData = responseData.signers.map((signer) => {
      let signerConfig = signer.signer_config[0] || {};
      return {
        id: signer.id,
        name: signer.name,
        desc: signer.desc,
        id_config: Object.keys(signerConfig).length > 0 ? signerConfig.id : 0,
        selfie: signerConfig?.selfie_enabled ? true : false,
        photo_doc: signerConfig?.official_document_enabled ? true : false,
        handwritten_signature: signerConfig?.handwritten_enabled ? true : false,
      };
    });
    const filteredData = newData.filter((item) => item.id_config !== 0);
    return filteredData;
  };

  function registerSigner(data) {
    setLoading(true);

    const { signer, type_sign } = data;
    let obj;
    const datas = signer
      .map((signer_id, index) => {
        const user_id = type_sign[index];
        // Verifica se user_id e signer_id não são vazios
        return user_id !== undefined &&
          user_id !== "" &&
          signer_id !== "" &&
          signer_id !== undefined
          ? { user_id: signer_id, signer_id: user_id }
          : undefined;
      })
      .filter((item) => item !== undefined);

    obj = {
      sale_id: idSale,
      signer_id: datas[0].signer_id,
      user_id: datas[0].user_id,
    };

    const notification = toast.loading(
      "Por favor, aguarde a ação está sendo realizada..."
    );

    postConfigContract(obj)
      .then(() => {
        refetchRegisterSigners().then(() => {
          toast.update(notification, {
            render: "Signatários adicionados com sucesso!",
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
            type: "success",
            isLoading: false,
          });
        });
      })
      .catch((error) => {
        toast.update(notification, {
          render: `Não foi possível adicionar os signatários! ${error}`,
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
          type: "error",
          isLoading: false,
        });
        console.error("Erro ao adicionar signatários:", error);
      })
      .finally(() => {
        setLoading(false);
        setNewSigner([{}]);
        formSigner.reset();
      });
  }

  useEffect(() => {
    if (config_sign && config_sign.signers) {
      const newData = transformData(config_sign);
      setTransformedData(newData);
    }
  }, [config_sign]);

  return (
    <Modal
      visible={visible}
      dynamicTitle={"Cadastrar Signatário"}
      onHide={() => setVisible(false)}
      position="center"
    >
      <form onSubmit={formSigner.handleSubmit(registerSigner)}>
        <div className="row">
          <div className="card-border me-2 my-2">
            <div className="title-container">
              <p>
                {" "}
                <i className="fa-solid fa-users me-2"></i>Signatários
              </p>
            </div>
            <div className="col-md-12 row my-2 p-4">
              <>
                <h4 className="text-success">
                  <i className="fa-solid fa-circle-plus mx-2"></i>Cadastro de
                  Signatários
                </h4>
                <hr></hr>
                {newSigner.map((cli, index) => (
                  <div className="row" key={index}>
                    <div className="col-md-4 mb-1">
                      <Select
                        isRequired={true}
                        name={`signer[${index}]`}
                        label={
                          isLoadingSigners ? "Carregando..." : "Signatário"
                        }
                        disabled={isLoadingSigners}
                        errors={errorsFile}
                        control={formSigner.control}
                        options={
                          signers &&
                          signers?.map((item) => {
                            return {
                              value: item.id,
                              label: item.name,
                            };
                          })
                        }
                      />
                    </div>
                    <div className="col-md-4 mb-1">
                      <Select
                        isRequired={true}
                        name={`type_sign[${index}]`}
                        label={
                          isLoading ? "Carregando..." : "Tipo de Signatário "
                        }
                        disabled={isLoading}
                        errors={errorsFile}
                        control={formSigner.control}
                        options={
                          transformedData &&
                          transformedData.map((item) => {
                            return {
                              value: item.id_config,
                              label: item.name,
                            };
                          })
                        }
                      />
                    </div>
                    <div className="col-md-3 ms-2 pt-4"></div>
                  </div>
                ))}
                <div className="col-md-12 mt-4 align-self-end text-end">
                  {" "}
                  <Button
                    rounded
                    type="submit"
                    loading={loading}
                    iconPos="right"
                    label="Adicionar"
                    icon="fa-solid fa-circle-chevron-right"
                    className="p-inputtext-sm m-auto"
                  />
                </div>
              </>
            </div>
          </div>
        </div>
      </form>
    </Modal>
  );
};
